import React, { useState } from 'react';
import { Info, ChevronUp, ChevronDown } from 'lucide-react';
import { toast } from 'sonner';
import type { VariablesData, CustomVariable } from './types';

// ── Variables Reference Panel ─────────────────────────────────────────────────

interface VariablesReferenceProps {
  variables: VariablesData | undefined;
  customVars: CustomVariable[];
}

export default function VariablesReference({ variables, customVars }: VariablesReferenceProps) {
  const [open, setOpen] = useState(false);
  const builtins = variables?.builtin ?? [];
  const total = builtins.length + customVars.length;

  return (
    <div style={{ border: '1px solid rgba(255,255,255,0.10)', borderRadius: 'var(--radius-card)', background: 'var(--glass-bg-card)', overflow: 'hidden' }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          width: '100%', display: 'flex', alignItems: 'center', gap: '0.4rem',
          padding: '0.5rem 0.625rem', background: 'none', border: 'none',
          cursor: 'pointer', textAlign: 'left', color: 'var(--color-text)',
        }}
      >
        <Info size={13} style={{ color: 'var(--color-primary)', flexShrink: 0 }} />
        <span style={{ flex: 1, fontWeight: 600, fontSize: 'var(--text-sm)', color: 'var(--color-text)' }}>
          Riferimento variabili ({total})
        </span>
        {open
          ? <ChevronUp size={12} style={{ color: 'var(--color-text-faint)' }} />
          : <ChevronDown size={12} style={{ color: 'var(--color-text-faint)' }} />}
      </button>

      {open && (
        <div style={{ padding: '0 0.625rem 0.625rem', maxHeight: 280, overflowY: 'auto' }}>
          <table style={{ width: '100%', fontSize: 11, borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', padding: '4px 6px', borderBottom: '1px solid rgba(255,255,255,0.10)', color: 'var(--color-text-muted)', fontWeight: 600 }}>Chiave</th>
                <th style={{ textAlign: 'left', padding: '4px 6px', borderBottom: '1px solid rgba(255,255,255,0.10)', color: 'var(--color-text-muted)', fontWeight: 600 }}>Descrizione</th>
              </tr>
            </thead>
            <tbody>
              {builtins.map(v => (
                <tr
                  key={v.key}
                  onClick={() => { navigator.clipboard.writeText(`{{${v.key}}}`); toast.success(`{{${v.key}}} copiato`); }}
                  style={{ cursor: 'pointer' }}
                >
                  <td style={{ padding: '4px 6px', fontFamily: 'monospace', color: 'var(--color-primary)', whiteSpace: 'nowrap' }}>{`{{${v.key}}}`}</td>
                  <td style={{ padding: '4px 6px', color: 'var(--color-text-muted)' }}>{v.desc}</td>
                </tr>
              ))}
              {customVars.map(cv => (
                <tr
                  key={cv.key}
                  onClick={() => { navigator.clipboard.writeText(`{{${cv.key}}}`); toast.success(`{{${cv.key}}} copiato`); }}
                  style={{ cursor: 'pointer' }}
                >
                  <td style={{ padding: '4px 6px', fontFamily: 'monospace', color: 'var(--color-warning)', whiteSpace: 'nowrap' }}>{`{{${cv.key}}}`}</td>
                  <td style={{ padding: '4px 6px', color: 'var(--color-text-muted)' }}>
                    {cv.label} <span style={{ fontSize: 9, opacity: 0.7 }}>(custom)</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
